<template>
    <div class="city-select" v-loading.fullscreen.lock="loading" element-loading-background="rgba(255, 255, 255, 0.3)">
        <div class="box-card" >
            <div class="province" v-for="p in cityList" :key="p.id">
                <div class="title">{{p.name}} (<span class="blue">{{p.count}}</span>)</div>
                <div class="city">
                    <span class="item" v-for="c in p.children" :key="c.id" @click="clickCity(c)">
                        {{ c.name }} (<span class="blue">{{c.count}}</span>)
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            cityList: [],
            loading: false,
												userdata:{},
        }
    },
    mounted(){
					this.userdata=this.getuseriformation();
        var cityList = this.$store.state.cityList;
								
        if(cityList && cityList.length){
            this.cityList = cityList;
            return;
        }

        this.loading = true;
        this.$axios.get(this.$api.cyl.map.mapcity(),{
											headers: {
												AuthToken: this.userdata.token
											}
										}).then(res => {
            this.loading = false;
            if(res.data.success){
                this.cityList = res.data.list;
                this.$store.commit('setCityList', this.cityList);
            }
        }).catch(e => {
            this.loading = false;
        });
    },
    methods:{
        clickCity(city){
            //console.log(city);
            this.$emit('select', city);
        }
    }
}
</script>

<style lang="scss">
    .city-select{
        position: absolute; z-index:999;  width:100%;
        height:650px; overflow-y: scroll;
        .box-card{
            padding:15px 0;
        }
        .title{
            background:#f8f8f8; padding:5px 22px; font-weight: bold;
        }
        .city{
            padding:15px 22px; line-height:25px;
        }
        .item{
            margin-right:12px; cursor: pointer;
            &:hover{
                color:#03c; text-decoration: underline;
            }
        }
        .blue{
            color:rgb(16, 111, 189);
        }
    }
</style>